/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type ShopConsentDto = {
    id: string;
    createdAt: string;
    updatedAt?: string;
    name: string;
    type: ShopConsentDto.type;
    description: string;
    remark: string;
    version: number;
};
export namespace ShopConsentDto {
    export enum type {
        INSTALLMENT = 'INSTALLMENT',
        PDPA = 'PDPA',
    }
}

